import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  Box,
  Tooltip,
  removerProdutoListaProdutos,
  IconButton,
  Flex,
  useToast
} from "@chakra-ui/react";

import ProdutoImagem from "../ProdutoImagem";
import { FaTrash } from 'react-icons/fa';

const ModalListaProdutos = ({ produtos, isOpenModalListaProdutos, setIsOpenModalListaProdutos, closeModalListaProdutos, openModalListaProdutos, removerProdutoListaProdutos }) => {
  const toast = useToast()

  const formatarProdutosParaCopia = () => {
    return produtos
      .map(
        (produto) =>
          `Nome: ${produto.nome}\n` +
          `Código Global: ${produto.codigo_global}\n` +
          `Fabricante: ${produto.fabricante_nome}\n` +
          `Preço: R$${formatarPreco(produto.valor_venda)}\n` +
          `Link: ${produto.link_ms}\n------------------------------------------- \n`
      )
      .join("\n");
  };

  const copiarListaProdutos = () => {
    if (produtos && produtos.length == 0) {
      toast({
        title: `Nenhum produto selecionado`,
        status: 'error',
        isClosable: true,
        duration: 1000,
      });
      return;
    }
    const textoParaCopiar = formatarProdutosParaCopia();
    navigator.clipboard.writeText(textoParaCopiar);
    toast({
      title: `Lista de produtos copiada para a área de transferência!`,
      status: 'success',
      isClosable: true,
    })
  };

  const formatarPreco = (valor) => {
    const numero = Number(valor);
    if (isNaN(numero)) return "0,00";
    return numero.toFixed(2).replace(".", ",");
  };

  function limitarCaracteres(str, limite) {
    if (str.length > limite) {
      return str.slice(0, limite) + "...";
    }
    return str;
  }

  return (
    <>
      <Modal isOpen={isOpenModalListaProdutos} onClose={closeModalListaProdutos} size={{ base: "md", md: "xl", lg: "3xl", xl: "4xl" }}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Text fontSize={"18px"}>Listagem de Produtos</Text>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {produtos.map((produto, index) => (
              <Flex flexDirection="column" key={produto.produto_id} mb={4}>
                <Flex flexDirection={{ base: "column", md: "row" }} fontSize={"13px"} justify={"start"} align={"center"} textAlign={"center"}>
                  <Tooltip label={"Remover da Lista"}>
                    <IconButton
                      mr={2}
                      size={"xs"}
                      aria-label="Remover"
                      icon={<FaTrash size={10} />}
                      colorScheme="red"
                      onClick={() => removerProdutoListaProdutos(produto.produto_id)}
                    />
                  </Tooltip>
                  <Text>
                    {index + 1}){" "}
                  </Text>
                  <ProdutoImagem
                    produto={produto}
                    origem={""}
                    width={"35px"}
                    height={"35px"}
                  />
                  <Flex flexDirection="row" textAlign={"center"} align={"center"}>
                    <Text align={"center"} textAlign={"center"} fontWeight="bold" ml={1}>Nome:</Text>
                    <Text align={"center"} textAlign={"center"} ml={1}>{limitarCaracteres(produto.nome, 25)}</Text>
                  </Flex>

                  <Flex flexDirection="row">
                    <Text fontWeight="bold" ml={1}>Código Global:</Text>
                    <Text ml={1}>{produto.codigo_global}</Text>
                  </Flex>

                  <Flex flexDirection="row">
                    <Text fontWeight="bold" ml={1}>Fabricante:</Text>
                    <Text ml={1}>{produto.fabricante_nome}</Text>
                  </Flex>

                  <Flex flexDirection="row">
                    <Text fontWeight="bold" ml={1}>Preço:</Text>
                    <Text ml={1}>R$ {formatarPreco(produto.valor_venda)}</Text>
                  </Flex>
                </Flex>
                <Flex flexDirection="row" justify={"start"} align={"center"} textAlign={"center"}>
                  <Text fontSize={"14px"} fontWeight="bold" ml={1}>Link:</Text>
                  <Text ml={1} fontSize={"12px"} fontWeight={"bold"} color={"blue"}>{produto.link_ms ? produto.link_ms : ' ---- '}</Text>
                </Flex>
              </Flex>
            ))}
          </ModalBody>
          <ModalFooter>
            {/* Botão para copiar a lista */}
            <Button colorScheme="green" onClick={copiarListaProdutos}>
              Copiar Lista
            </Button>
            <Button ml={3} onClick={closeModalListaProdutos}>
              Fechar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal >
    </>
  );
};

export default ModalListaProdutos;
